"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reducers = _interopRequireDefault(require("../reducers"));

var _usageTracker = _interopRequireDefault(require("../lib/usageTracker"));

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // Usage tracking middleware should be moved to a better handler pattern.
// this was done to support the redux update.

var usageTrackerMiddleware = function usageTrackerMiddleware() {
  return function (next) {
    return function (action) {
      _usageTracker.default.logActionChange(action);

      return next(action);
    };
  };
};

var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default, usageTrackerMiddleware))(_redux.createStore);

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createStoreWithMiddleware(_reducers.default, initialState);
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/util/configureStore.js
// module id = 316
// module chunks = 0